import { render, staticRenderFns } from "./importTaskList.vue?vue&type=template&id=7fab4f54&scoped=true"
import script from "./importTaskList.vue?vue&type=script&lang=js"
export * from "./importTaskList.vue?vue&type=script&lang=js"
import style0 from "./importTaskList.vue?vue&type=style&index=0&id=7fab4f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fab4f54",
  null
  
)

export default component.exports